import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  list: [],
  error: "",
};

export default function CompanySpecialization(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Company.Specialization.SET_LIST:
      return { ...state, list: action.data };
    case Action.Company.Specialization.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Company.Specialization.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Company.Specialization.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
